module.exports = __webpack_public_path__ + "img/annotation.eed44b3e.svg";